import { render, staticRenderFns } from "./AreaCreate.vue?vue&type=template&id=f036047e&scoped=true"
import script from "./AreaCreate.vue?vue&type=script&lang=js"
export * from "./AreaCreate.vue?vue&type=script&lang=js"
import style0 from "./AreaCreate.vue?vue&type=style&index=0&id=f036047e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f036047e",
  null
  
)

export default component.exports